import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import { plainToClass } from 'class-transformer';
import { MutationFetchFunction } from 'common/helpers/common';
import { ApiError, MessageResult } from 'common/repositories/common.model';
import toApiError from 'common/repositories/to-api-error';
import { client } from 'hooks/use-ky';
import { decamelizeKeys } from 'humps';

import {
  SendOtpMutationInput,
  VerifyOtpMutationInput,
  VerifyOtpResult,
} from './model';

export function useSendOtp(
  options?: UseMutationOptions<MessageResult, ApiError, SendOtpMutationInput>,
) {
  return useMutation<MessageResult, ApiError, SendOtpMutationInput>(
    async function (body) {
      return await MutationFetchFunction({
        url: 'auth/send-otp',
        method: 'POST',
        classType: MessageResult,
        body,
      });
    },
    options,
  );
}

export function useVerifyOtp(
  options?: UseMutationOptions<
    VerifyOtpResult,
    ApiError,
    VerifyOtpMutationInput
  >,
) {
  return useMutation<VerifyOtpResult, ApiError, VerifyOtpMutationInput>(
    async function (body) {
      return new Promise(async (resolve, reject) => {
        const newBody = body ? decamelizeKeys(body) : undefined;

        try {
          const json = (await client('auth/verify-otp', {
            method: 'POST',
            ...(newBody
              ? {
                  json: newBody,
                }
              : {}),
          }).json()) as any;

          const transformedJson = plainToClass(VerifyOtpResult, json);

          resolve(transformedJson);
        } catch (e) {
          reject(await toApiError(e as Error));
        }
      });
    },
    options,
  );
}
